export class AuthDTO {
    public tenantID: string;
    public accessToken: string;
}
